export class NotAuthorizeError extends Error {
  constructor(message) {
    super(message || 'Not Authorize');
    this.name = "NotAuthorizeError";
    this.code = 401;
  }
}

export class NoDataFound extends Error {
  constructor(message) {
    super(message || 'No Data Found');
    Object.setPrototypeOf(this, NoDataFound.prototype);
    this.name = "NoDataFound";
    this.code = 404;
  }
}

export class BadRequest extends Error {
  constructor(message) {
    super(message || 'Bad request');
    this.name = "BadRequest";
    this.code = 400;
  }
}

export class GenericError extends Error {
  constructor(message) {
    super(message || 'Generic Error occured');
    this.name = "GenericError";
    this.code = 500;
  }
}